import React from 'react';

//search context
export const AppContext = React.createContext();

const useAppContext = () => {
    const context = React.useContext(AppContext);
    if(!context) {
        throw new Error('useAppContext must be used within a AppContextProvider');
    }
    return context;
}

const AppContextProvider = props => {
    const [headerTitle, setHeaderTitle] = React.useState();

    const value = React.useMemo(() => [headerTitle, setHeaderTitle], [headerTitle]);

    return (
        <AppContext.Provider value={value} {...props} />
    )
}

export default { AppContextProvider, useAppContext };